<template>
  <div class="field">
    <label :class="isFieldRequired || isRequired ? 'req' : ''"> {{ label }}</label>
    <p class="field_description" v-if="description">{{ description }}</p>
    <div v-if="id">
      <p class="contentLength">Количество символов: {{ tinymce_getContentLength }}</p>
      <p v-if="max_chars" class="contentLength">Максимальное количество символов: {{ max_chars }}</p>
    </div>
    <p>Для вставки текста используйте сочетание клавиш Ctrl + V на клавиатуре</p>
    <editor
      :disabled="isDataUpdating"
      :id="id"
      @blur="saveData"
      :init="{
                  plugins: 'lists link visualchars paste',
                  menubar:false,
                  paste_as_text: true,
                  toolbar: 'undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent'
                }"
      v-model="currentValue"
      @change="changeData"
      @keyPress="changeData"
      @nodeChange="changeData"
    ></editor>
  </div>
</template>

<script>

import Editor from '@tinymce/tinymce-vue';
import tinymce from 'tinymce/tinymce';
import "tinymce/tinymce";
import "tinymce/themes/silver";
import "tinymce/icons/default";

export default {
  name: "TinymceEditor",
  components: {
    'editor': Editor,
  },
  props: [
    'id',
    'label',
    'value',
		'modelValue',
    'objectKey',
    'parentKey',
    'description',
    'isDataUpdating',
    'max_chars',
		'isRequired'
  ],
  data() {
    return {
      currentValue: this.value,
      allowedKeys: [8, 37, 38, 39, 40, 46], // backspace, delete and cursor keys,
    }
  },
  mounted() {
    this.currentValue = this.modelValue;
	},
  methods: {
    saveData() {
      if (this.max_chars && this.tinymce_getContentLength < parseInt(this.max_chars)) {
        this.$emit('update', this.currentValue)
        if (typeof this.$parent.saveData === 'function') {
          this.$parent.saveData();
        }
      }
      if (!this.max_chars) {
        this.$emit('update', this.currentValue)
        if (typeof this.$parent.saveData === 'function') {
          this.$parent.saveData();
        }
      }
    },
    changeData(e) {
      if (this.max_chars) {
        if (this.allowedKeys.indexOf(e.keyCode) != -1 || this.tinymce_getContentLength < parseInt(this.max_chars)) {
          if(this.parentKey) {
            this.$parent.project[this.parentKey][this.objectKey] = this.currentValue;
          } else {
            this.$parent.project[this.objectKey] = this.currentValue;
          }
          this.$emit('update:modelValue', this.currentValue)
        } else {
          e.preventDefault();
          e.stopPropagation();
        }
      } else {
        if (this.$parent.project !== undefined && this.objectKey !== undefined) {
          if(this.parentKey) {
            this.$parent.project[this.parentKey][this.objectKey] = this.currentValue;
          } else {
            this.$parent.project[this.objectKey] = this.currentValue;
          }
          this.$emit('update:modelValue', this.currentValue)
        } else {
          if (this.$parent.project !== undefined && this.objectKey !== undefined) {
            if(this.parentKey) {
              this.$parent.project[this.parentKey][this.objectKey] = this.currentValue;
            } else {
              this.$parent.project[this.objectKey] = this.currentValue;
            }
          }
          this.$emit('update:modelValue', this.currentValue)
				}
      }
    },
    extractContent(s) {
      var span = document.createElement('span');
      span.innerHTML = s;
      return span.textContent || span.innerText;
    },
  },
  computed: {
    isFieldRequired() {
      if (typeof this.$parent.isFieldRequired === 'function') {
        return this.$parent.isFieldRequired(this.objectKey);
      } else {
        return false;
      }
    },
    tinymce_getContentLength() {
      if (this.id && this.currentValue) {
        return this.extractContent(this.currentValue).length;
      } else {
        return  0;
      }
    }
  }
}
</script>

<style scoped>
.field_description, .contentLength {
  font-size: 13px;
}
</style>